import React, {PureComponent} from 'react';
import Header from "../../view/components/header/header";
import Footer from "../../view/components/footer/footer";
import {Route, Switch} from "react-router-dom";
import {
    CommodityTemplate,
    ContactUs,
    HomePageUpdate,
    IntegrationMedia,
    LightMedia,
    News,
    NoticeInfo,
    Operation,
    ProvincePlatform
} from "../asyn";
import main_routes_all from "../../router/main_routes_all";
import {withTranslation} from 'react-i18next';

class Pages extends PureComponent {
    componentDidMount() {

    }

    render() {
        const {t} = this.props;
        return (
            <div className="Pages">
                <Header/>
                <div className='lingyun_market_content' style={{minHeight: "600px"}}>
                    <p> {t('h_contact_us')}</p>
                    <Switch>
                        <Route path={main_routes_all.pages.default} exact component={HomePageUpdate}/>
                        <Route path={main_routes_all.pages.home} exact component={HomePageUpdate}/>
                        <Route path={main_routes_all.pages.homeUpdate} exact component={HomePageUpdate}/>
                        {/*媒体云服务*/}
                        <Route path={main_routes_all.pages.commodityTemplate} exact component={CommodityTemplate}/>
                        {/*媒体解决方案*/}
                        <Route path={main_routes_all.pages.lightMedia} exact component={LightMedia}/>
                        <Route path={main_routes_all.pages.news} exact component={News}/>
                        <Route path={main_routes_all.pages.integrationMedia} exact component={IntegrationMedia}/>
                        <Route path={main_routes_all.pages.provincePlatform} exact component={ProvincePlatform}/>

                        <Route path={main_routes_all.pages.operation} exact component={Operation}/>

                        <Route path={main_routes_all.pages.noticeInfo} exact component={NoticeInfo}/>
                        <Route path={main_routes_all.pages.contactUs} exact component={ContactUs}/>

                    </Switch>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default withTranslation()(Pages);



// WEBPACK FOOTER //
// ./src/router/pages/pages.js